module.exports = __webpack_public_path__ + "static/media/ic_reduce.4f66fb9c.svg";